"use client";

import { c as _c } from "react/compiler-runtime";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { RecoverPwdSchema, RecoverPwdType } from "./validation";
import { useMutation } from "@tanstack/react-query";
import { useToast } from "@/hooks/use-toast";
import { useState } from "react";
import api from "@/actions/api";
import useSession from "@/hooks/QueryHooks/useSession";
import { useTranslations } from "next-intl";
import { useSocketContext } from "@/components/providers/SocketProvider/SocketProvider";
type Props = {
  handleCodeValidated: () => void;
};
export default function useValidateEmail(t0) {
  const $ = _c(27);
  const {
    handleCodeValidated
  } = t0;
  const {
    toast
  } = useToast();
  const t = useTranslations("modules.auth.validateEmail");
  const session = useSession();
  const {
    reconnectSocket
  } = useSocketContext();
  const userEmail = session?.data?.email;
  const [terms, setOpenTerms] = useState(false);
  const [termsAccepted, setTermsAccepted] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      resolver: zodResolver(RecoverPwdSchema),
      defaultValues: {
        emailCode: ""
      }
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const form = useForm(t1);
  let t2;
  if ($[1] !== handleCodeValidated || $[2] !== reconnectSocket || $[3] !== session) {
    t2 = () => {
      reconnectSocket();
      session.refetch();
      handleCodeValidated();
    };
    $[1] = handleCodeValidated;
    $[2] = reconnectSocket;
    $[3] = session;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t || $[6] !== toast) {
    t3 = error => {
      toast({
        variant: "destructive",
        title: t("verificationFailedTitle"),
        description: error?.message || t("genericError")
      });
    };
    $[5] = t;
    $[6] = toast;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t2 || $[9] !== t3) {
    t4 = {
      mutationFn: api.auth.validateEmail,
      onSuccess: t2,
      onError: t3
    };
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const {
    mutate: recoverPwdMutation,
    isPending: isPendingRecoverPwd
  } = useMutation(t4);
  let t5;
  if ($[11] !== recoverPwdMutation) {
    t5 = function onSubmit(data) {
      recoverPwdMutation(data);
    };
    $[11] = recoverPwdMutation;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  const onSubmit = t5;
  let t6;
  if ($[13] !== t || $[14] !== toast) {
    t6 = {
      mutationFn: api.auth.resendValidateEmail,
      onSuccess: data_0 => {
        toast({
          variant: "success",
          title: t("resendSuccessTitle"),
          description: t("resendSuccessDescription")
        });
      },
      onError: error_0 => {
        toast({
          variant: "destructive",
          title: t("resendFailedTitle"),
          description: error_0?.message || t("genericError")
        });
      }
    };
    $[13] = t;
    $[14] = toast;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  const {
    mutate: resendValidateEmail
  } = useMutation(t6);
  let t7;
  if ($[16] !== resendValidateEmail || $[17] !== userEmail) {
    t7 = () => {
      if (!userEmail) {
        return;
      }
      resendValidateEmail({
        email: userEmail
      });
    };
    $[16] = resendValidateEmail;
    $[17] = userEmail;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  const handleResendValidationCode = t7;
  let t8;
  if ($[19] !== form || $[20] !== handleResendValidationCode || $[21] !== isPendingRecoverPwd || $[22] !== onSubmit || $[23] !== t || $[24] !== terms || $[25] !== termsAccepted) {
    t8 = {
      form,
      onSubmit,
      isPendingRecoverPwd,
      terms,
      termsAccepted,
      setTermsAccepted,
      setOpenTerms,
      handleResendValidationCode,
      t
    };
    $[19] = form;
    $[20] = handleResendValidationCode;
    $[21] = isPendingRecoverPwd;
    $[22] = onSubmit;
    $[23] = t;
    $[24] = terms;
    $[25] = termsAccepted;
    $[26] = t8;
  } else {
    t8 = $[26];
  }
  return t8;
}